import React from "react";
import { Button, Typography } from "@mui/material";

const ReportFoundItemOverlay = ({ onClose }) => {
  return (
    <div>
      <Typography variant="h6" sx={{ mb: 2 }}>Report Found Item</Typography>
      {/* Your form or content here */}
      <Button onClick={onClose} variant="contained" sx={{ mt: 2 }}>
        Close
      </Button>
    </div>
  );
};

export default ReportFoundItemOverlay;
